import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    host_url: process.env.VUE_APP_BASE_API
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
